import { IServiceClient } from 'src/interfaces/serviceClient';
import { handleGetPhoneAgencies } from 'src/modules/store/helpers';
import { isPluginAvailable } from 'src/utils/store/isPluginAvailable';
import { CALLS_PLUGIN } from 'src/constants/plugins';
import { SERVICE_LEAD_TYPE } from 'src/constants/lead/leadTypes';

export const canMakeCallToServiceClient = (
    client: IServiceClient | null
): boolean => {
    if (
        !client ||
        !client.store ||
        typeof client.store === 'string' ||
        !client.store._id
    ) {
        return false;
    }

    const store = client.store;

    if (!store.areas) {
        return false;
    }

    const { success } = handleGetPhoneAgencies({
        area: SERVICE_LEAD_TYPE,
        areas: store.areas,
    });

    if (!success) {
        return false;
    }

    return isPluginAvailable(store, CALLS_PLUGIN);
};
